/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Help_CenterInputs */

const en_common_help_center = /** @type {(inputs: Common_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Center`)
};

const es_common_help_center = /** @type {(inputs: Common_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de ayuda`)
};

/**
* | output |
* | --- |
* | "Help Center" |
*
* @param {Common_Help_CenterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_help_center = /** @type {((inputs?: Common_Help_CenterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Help_CenterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_help_center(inputs)
	return en_common_help_center(inputs)
});